export const stripe = {
  "secretKey": "sk_test_51HYbmFI41a7FhhGLfe2WiyStKUNT3t4begQogVsM8EPaM0PHFTikCPe0772zBktNGbE7N3gmLnYd1nDRV6Y87HXA001ZD54dNV",
  "publishableKey": "pk_test_51HYbmFI41a7FhhGLHXRfv3mAgWPiwMBAvYNDdTP5y5WAU7BG5WFzBpo0mKgoeSH8jCdWLm9ItVm6q9d7ideLKEBz00PjXVZ69T"
};